import { z as e, p as i, v as c } from "./v1-BlFVAz1H.js";
import { p as t, v as o } from "./v2-BSCAhUOH.js";
import { p as s, l as n } from "./v3-CYCjpO46.js";
const p = e.discriminatedUnion("version", [
  e.object({
    version: e.literal(1),
    priceCheck: i,
    priceCheckExperience: e.string().nullish()
  }),
  e.object({
    version: e.literal(2),
    priceCheck: t,
    priceCheckExperience: e.string().nullish()
  }),
  e.object({
    version: e.literal(3),
    priceCheck: s,
    priceCheckExperience: e.string().nullish()
  })
]), l = e.preprocess((r) => typeof r == "object" && r !== null && !("version" in r) ? { ...r, version: 1 } : r, p), u = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  latest: n,
  v1: c,
  v2: o,
  versionedResult: l
}, Symbol.toStringTag, { value: "Module" }));
export {
  u as i,
  l as v
};
